import styles from '@styles/scss/performer/_hybridClient.module.scss';
import genderUrl from 'lib/functions/genderFunction';
import { OfflinePerformer } from 'lib/types/item/offlinePerformer';
import { Performer } from 'lib/types/item/performer';
import Image from 'next/image';
import Link from 'next/link';

export default function HybridClient({
    performer,
    gender,
    offlinePerformer,
    currentLang
}: {
    performer: Performer;
    gender: string;
    offlinePerformer: OfflinePerformer;
    currentLang: string;
}): JSX.Element {
    if (performer.is_online === 1) {
        /* Add Iframe to load in performer stream */
        return (
            <div
                id="chatroom"
                data-event-category="Outbound Click"
                data-event-action="Performer - Iframe"
                data-event-label="Iframe"
                className={styles.chatRoomDiv}>
                <div id="object_container"></div>
            </div>
        );
    } else {
        const src = `${performer.gallery_image.replace('jpg', 'webp')}`;
        /* add placeholder image of performer */
        return (
            <div className={styles.performerContainer}>
                <Image
                    loader={() => src}
                    src={src}
                    alt={performer.username}
                    height={675}
                    width={1200}
                    priority={true}
                />
                <a
                    className={`${styles.moreBtn} ${styles.buttonStyle}`}
                    href={`https://rabbits.webcam/?id=2333&product_id=36&tag=signup&passthru1=${gender}&passthru2=${currentLang}&exid={exid}&tfid={tfid}`}
                    data-event-category="Outbound Click"
                    data-event-action="Join Click"
                    data-event-label="Header-CTA">
                    {offlinePerformer.more_of_performer}
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="https://www.w3.org/2000/svg">
                        <path
                            d="M5 2L10 7L5 12"
                            stroke="#FFF"
                            strokeMiterlimit="10"
                            strokeLinecap="square"
                            strokeLinejoin="round"
                        />
                    </svg>
                </a>
                <Link
                    href={genderUrl(gender)}
                    data-event-category="Outbound Click"
                    data-event-action="Join Click"
                    data-event-label="Header-CTA">
                    <a className={`${styles.homeBtn} ${styles.buttonStyle}`}>
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="https://www.w3.org/2000/svg">
                            <path
                                d="M9 2L4 7L9 12"
                                stroke="white"
                                strokeMiterlimit="10"
                                strokeLinecap="square"
                                strokeLinejoin="round"
                            />
                        </svg>
                        {offlinePerformer.back_to_home}
                    </a>
                </Link>
            </div>
        );
    }
}
